<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4">
      <div class="text-h4 mb-4" v-show="!showSkeleton">Atualizar Grupo de Ramal - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroGrupoRamal edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import gruposRamaisStore from '../_store'

import CadastroGrupoRamal from './CadastroGrupoRamal'

export default {
  name: 'AtualizarGrupoRamal',
  props: {
    _id: String,
  },
  components: { CadastroGrupoRamal, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarGrupoRamaisModulePABXStore', ['getGrupoRamalSelecionado']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarGrupoRamaisModulePABXStore', gruposRamaisStore)

    await this.listarGrupoRamalSelecionado(this._id)
    this.description = this.getGrupoRamalSelecionado.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarGrupoRamaisModulePABXStore', ['listarGrupoRamalSelecionado']),
  },
}
</script>
